import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import '../pages-styles/project-consultancy.css';

function WorksList() {
  const { service } = useParams();
  const [works, setWorks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchWorks = async () => {
      setLoading(true);
      try {
        const res = await fetch(`/api/works?service=${encodeURIComponent(service)}`);
        if (!res.ok) throw new Error('Failed to fetch');
        const data = await res.json();
        setWorks(data || []);
      } catch (err) {
        console.error(err);
        setWorks([]);
      } finally {
        setLoading(false);
      }
    };
    fetchWorks();
  }, [service]);

  return (
    <div className="works-page">
      <section className="page-intro">
        <h1>Works — {service ? service.replace(/-/g,' ') : 'Projects'}</h1>
        <p>Explore recent projects and case studies for {service && service.replace(/-/g,' ')}.</p>
      </section>

      <section className="works-grid">
        {loading && <p>Loading...</p>}
        {!loading && works.length === 0 && <p>No works found yet.</p>}
        <div className="works-list">
          {works.map(w => (
            <div key={w.id} className="work-card">
              {w.image && <img src={w.image} alt={w.title} />}
              <h3>{w.title}</h3>
              <p>{w.description}</p>
              <div className="work-actions">
                <Link to={`/work/${w.id}`} className="btn">View</Link>
                {w.url && <a className="btn secondary" href={w.url} target="_blank" rel="noreferrer">Live</a>}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default WorksList;
